export default {
  data: {
    products: [],
  },
  configurator: {
    showResults: false,
    showScrollIndicator: false,
    lastQuestionId: '',
    questions: [],
    results: [
      /* shower systems 
      [{
        "products": ["30328001", "31498000"],
        "bundle": [""]
      }, {
        "products": ["29123000", "27746000"],
        "bundle": ["27704000", "27704000","26458000","27704000"]
      }, {
        "products": ["29123000", "27732000"],
        "bundle": ["26458000","27732000", "27704000"]
      }, {
        "products": ["29123000", "27734000","26458000","26073000"],
        "bundle": []
      }, {
        "products": ["29123000"],
        "bundle": ["35600000", "27704000"]
      }, {
        "products": ["29123000", "27700000"],
        "bundle": ["35600000" ]
      }]
    water systems */
      /*[{
        "products": ["30341DC1"],
        "bundle": ["30341001"]
      },{
        "products": ["30329001"],
        "bundle": ["30328DC1"]        
      }]*/
    ]
  }
};



// WEBPACK FOOTER //
// ./src/reducers/initialState.js